// Copyright 2026 Bitech.id. Licensed under the MIT License.

import type { BiwaveEvent, BiwaveTarget, LogEvent, PulseEvent } from '../types.js';

export function buildEnvelope(event: BiwaveEvent, target: BiwaveTarget): string {
  const payload = JSON.stringify(event);
  const length = new TextEncoder().encode(payload).length;

  const envelopeHeader = JSON.stringify({
    event_id: event.event_id,
    sent_at: new Date().toISOString(),
    client_id: target.clientId,
  });

  const itemHeader = JSON.stringify({ type: 'event', length });

  return `${envelopeHeader}\n${itemHeader}\n${payload}\n`;
}

// /api/log expects a plain single JSON body, not the NDJSON envelope format
// /api/trace uses.
export function buildLogPayload(logs: LogEvent[], target: BiwaveTarget): string {
  return JSON.stringify({ client_id: target.clientId, logs });
}

// /api/pulse follows the same plain-JSON-batch convention as /api/log.
export function buildPulsePayload(pulses: PulseEvent[], target: BiwaveTarget): string {
  return JSON.stringify({ client_id: target.clientId, pulses });
}
